import angular from 'angular';
import featureManagement from './featureManagement';

export default angular
  .module('components.featureManagement', [])
  .component('featureManagement', featureManagement).name;
